import * as $ from "jquery";
import * as _ from "lodash";
import * as angular from "angular";
import { PrivacyNotice } from "../../models/privacy-notice.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { PrivacyNoticeDataProvider } from "../../data-provider/privacy-notice.dp";

let PrivacyNoticeListComponent = {
    selector: "vcPrivacyNoticeList",
    templateUrl:
        "/angular/components/privacy/privacy-notice-list.component.html",
    bindings: {
        privacyNotices: "=?",
        privacyNotice: "=?",
    },
    controller: class PrivacyNoticeListController {
        // * bindings for typescript compiler *
        public privacyNotices?: any;
        public privacyNotice?: any;
        // ************************************

        private $scope: any;
        private dialog: DialogUtils;
        public dataProvider: PrivacyNoticeDataProvider;

        constructor(
            $scope: any,
            PrivacyNoticeDataProvider: PrivacyNoticeDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = PrivacyNoticeDataProvider;
        }

        openPrivacyNoticeFormDialog(
            ev: any,
            privacyNotice: PrivacyNotice
        ): void {
            this.privacyNotice =
                _.cloneDeep(privacyNotice) || new PrivacyNotice();

            this.dialog.show({
                component: "vc-privacy-notice-form",
                targetEvent: ev,
                scope: this.$scope,
                clickOutsideToClose: false,
                locals: {
                    privacyNotice: this.privacyNotice,
                    privacyNotices: this.privacyNotices,
                },
                onComplete: (s: any, e: any) => {
                    $(e).find("input").first().focus();
                },
            });
        }

        openPrivacyNoticeViewDialog(
            ev: any,
            privacyNotice: PrivacyNotice
        ): void {
            this.privacyNotice =
                _.cloneDeep(privacyNotice) || new PrivacyNotice();

            this.dialog.show({
                component: "vc-privacy-notice-view",
                targetEvent: ev,
                scope: this.$scope,
                clickOutsideToClose: false,
                locals: {
                    privacyNotice: this.privacyNotice,
                },
            });
        }
    },
};

angular
    .module("privacy")
    .component(PrivacyNoticeListComponent.selector, PrivacyNoticeListComponent);
